import React, { useEffect, useState, useRef } from "react";

const MediaUpload = ({
    label,
    className,
    imgClassName,
    setIsImagePresent,
    clearMedia,
    setImageUpload,
    existingImage,
    stateImage,
    setStateImageUpload,
    id, // Unique identifier for each instance,
    hideBtns = false, // Optional prop to hide buttons
    useFileObject = false, // New prop: if true, pass File object instead of base64
    onClear, // New prop: callback when image is cleared/deleted
}) => {
    const inputRef = useRef(null);
    const [image, setImage] = useState(stateImage || null);

    const getAndUpload = async (file) => {
        // Check if file is a Blob or File object
        if (!file || !(file instanceof Blob)) return;

        if (useFileObject) {
            // Pass File object directly (for Image API V2)
            setImageUpload(file);
        } else {
            // Convert to base64 (legacy behavior)
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setImageUpload(reader.result);
            };
        }
    };



    useEffect(() => {
        if (image) {
            if (setStateImageUpload)
                setStateImageUpload(image);

            // Only call getAndUpload if image is a valid Blob/File
            if (image instanceof Blob) {
                getAndUpload(image);
            }
        }
        else {
            if (setStateImageUpload)
                setStateImageUpload(null);
        }
    }, [image]);

    useEffect(() => {
        if (clearMedia) {
            setImage(null);
        }
    }, [clearMedia]);

    return (
        <div className={`flex flex-col w-full h-72 ${className}`}>
            <div className="flex flex-col grow font-semibold h-full">
                <label htmlFor={`upload-${id}`} className="self-start text-base text-gray-900">
                    {label}
                </label>

                {image || existingImage ? (
                    <div className={`w-96 h-72 mt-2.5 flex flex-col object-cover rounded relative ${imgClassName}`}>
                        <img
                            src={image instanceof Blob ? URL.createObjectURL(image) : existingImage}
                            alt={` ${image ? "image" : "existing image"}`}
                            className="w-full h-full object-cover rounded-md"
                        />
                        {/* <button onClick={() => setImage(null)} className="text-white py-1 px-3 border-r basis-1/2 rounded-bl-md">
                            Edit
                        </button> */}
                        {!hideBtns ? (
                            <div className="absolute w-full flex transition-colors justify-between bottom-0 rounded-b-md">
                                <button type="button" onClick={() => window.open(image || stateImage, '_blank')} className="text-white bg-[rgba(0,0,0,0.3)] hover:bg-primaryHoverDark py-1 px-3 border-r basis-1/2 rounded-bl-md">
                                    View
                                </button>
                                <button type="button" onClick={() => { setImage(null); setImageUpload(''); onClear && onClear(); }} className="text-white bg-[rgba(0,0,0,0.3)] hover:bg-primaryHoverDark py-1 px-3 basis-1/2 rounded-br-md">
                                    Delete
                                </button>
                            </div>
                        ) : (
                            <div className="absolute w-full flex transition-colors justify-between bottom-0 rounded-b-md">
                                <button type="button" onClick={() => window.open(image || stateImage, '_blank')} className="text-white bg-[rgba(0,0,0,0.3)] hover:bg-primaryHoverDark py-1 px-3 w-full rounded-b-md">
                                    View
                                </button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="flex flex-col justify-center px-10 py-12 mt-2.5 text-xs text-center bg-white rounded-md border border-solid border-navBtn text-neutral-900 max-md:px-5 w-full h-full max-md:max-w-full">
                        <div className="flex flex-col justify-center items-center min-h-[151px]">
                            <div className="flex flex-col justify-center items-center px-16 py-9 rounded-2xl border border-dashed border-navBtn w-[335px] max-md:px-5">
                                <div className="flex flex-col max-w-full w-[108px]">
                                    <div className="flex flex-col justify-center items-center">
                                        <img
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/dd1772d5874b5cdae8c5ddfe78830a7b7d00a521b518ad3a0f1c5f229c7196d5"
                                            alt="Upload Placeholder"
                                            className="object-contain self-center w-8 aspect-square"
                                        />
                                        <div className="mt-1.5 opacity-70 text-base">Upload Media Here</div>
                                        <input
                                            ref={inputRef}
                                            type="file"
                                            accept="image/*,video/*"
                                            className="hidden"
                                            id={`upload-${id}`}
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setImage(file);
                                                    setIsImagePresent && setIsImagePresent(true);
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor={`upload-${id}`}
                                            className="cursor-pointer py-2 px-4 bg-navBtn text-sm font-semibold rounded hover:bg-primaryHover2"
                                        >
                                            Choose File
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
};

export default MediaUpload;